import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import {Container, Grid, Icon, Image, Menu, Segment} from "semantic-ui-react";

import {fetchCategoriesFavorites} from "../../redux/actions";

import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";

const city = JSON.parse(localStorage.getItem('_CITY'));
const city_id = city['value'];
const subdomain = window.location.host.split('.')[0];

export const Footer = () => {

    const [favorites, setFavorites] = useState([]);

    const cities = useSelector(state => state.Cities.results);

    useEffect(() => {

        async function fetchCategoriesData() {
            const res = await fetchCategoriesFavorites(city_id);

            setFavorites(res.data);
        }

        async function fetchCitiesData() {
            if (cities.success) {
                const options = cities.data.filter((o) => {
                    return (o.favorite && !o.future);
                });
                setFavorites(options);
            }
        }

        if (city_id === 7) {
            // noinspection JSIgnoredPromiseFromCall
            fetchCitiesData();
        } else {
            // noinspection JSIgnoredPromiseFromCall
            fetchCategoriesData();
        }

    }, [city_id, cities])

    const time = new Date();
    const year = time.getFullYear();

    const logo = ["italia", "europa"].includes(subdomain) ? "italia" : "geral";

    return (

        <Segment as="section" inverted basic className={`section-footer footer-${subdomain}`}>
            <Container>
                <Grid>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                        <Image
                            src={`/images/logo-footer-${logo}.png`}
                            className="logo-footer"
                        />
                        <p><FormattedMessage
                            id={'copyright'}
                            defaultMessage={"© {year} Direitos Reservados"}
                            values={{year}}
                        /></p>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                        <Menu text vertical inverted>
                            <Menu.Item header><FormattedMessage id="Sobre o IN BH"/></Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to={'/read/33/history'}
                            >
                                <FormattedMessage id="História"/>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to={'/contact'}
                            >
                                <FormattedMessage id="Contato"/>
                            </Menu.Item>
                            {/*<Menu.Item*/}
                            {/*    href={'/read/31/privacy'}*/}
                            {/*>*/}
                            {/*    <FormattedMessage id="Privacidade"/>*/}
                            {/*</Menu.Item>*/}
                            <Menu.Item
                                as={NavLink}
                                to={'/read/32/terms-of-use-and-privacy'}
                            >
                                <FormattedMessage id="Termos de Uso e Privacidade"/>
                            </Menu.Item>
                        </Menu>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={4} computer={4}>
                        <Menu text vertical inverted>
                            <Menu.Item header>
                                <FormattedMessage
                                    id={logo === 'geral' ? 'Categorias' : 'Cidades'}
                                />
                            </Menu.Item>
                            {
                                favorites.map((favorite) => {
                                    return (
                                        <Menu.Item
                                            key={`favorite-${favorite.id}`}
                                            onClick={
                                                () => {
                                                    localStorage.setItem('_CITY', JSON.stringify({
                                                        key: favorite.id,
                                                        text: favorite.name,
                                                        slug: favorite.slug,
                                                        value: favorite.id
                                                    }));
                                                    window.top.location.href = '/'
                                                }
                                            }
                                            // href={
                                            //     () => {
                                            //         return logo === 'geral'
                                            //             ? `/categories/${favorite.id}/${favorite.slug}?id=${favorite.id}`
                                            //             : '/'
                                            //     }
                                            // }
                                            title={favorite.name}
                                        >
                                            {favorite.name}
                                        </Menu.Item>
                                    );
                                })
                            }
                        </Menu>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={3} computer={3}>
                        <Menu text vertical inverted>
                            <Menu.Item header>Menu</Menu.Item>
                            {
                                city_id !== 7 && <Menu.Item
                                    as={NavLink}
                                    to={`/city/${city.value}/${city.slug}/home/0/0`}
                                >
                                    <FormattedMessage id="A Cidade"/>
                                </Menu.Item>
                            }
                            <Menu.Item
                                as={NavLink}
                                to={`/columnists/${city.value}/${city.slug}/home/0/0`}
                            >
                                <FormattedMessage
                                    id={["europa", "italia"].includes(subdomain) ? "Famílias" : "Cult In Minas"}/>
                            </Menu.Item>
                            {
                                city_id !== 7 && <Menu.Item
                                    as={NavLink}
                                    to={'/events'}
                                >
                                    <FormattedMessage id="Eventos"/>
                                </Menu.Item>
                            }
                            <Menu.Item
                                as={NavLink}
                                to={'/search'}
                            >
                                <FormattedMessage id="Pesquisar"/>
                            </Menu.Item>
                            {
                                !["europa", "italia"].includes(subdomain) ?
                                    <Menu.Item>
                                        <a href={"https://europa.inbh.com.br"}>
                                            <FormattedMessage id="IN EUROPA"/>
                                        </a>
                                    </Menu.Item> : <Menu.Item>
                                        <a href={"https://inbh.com.br"}>
                                            <FormattedMessage id="IN BH"/>
                                        </a>
                                    </Menu.Item>
                            }
                        </Menu>
                    </Grid.Column>
                </Grid>
            </Container>
            <Container fluid className="social-media">
                <Container>
                    <Menu borderless icon inverted>
                        <Menu.Item
                            href={'https://www.facebook.com/guiainbh/'}
                            target={'_blank'}
                            alt={'Facebook'}
                            title={'Facebook'}
                        >
                            <Icon name="facebook f"/>
                        </Menu.Item>
                        <Menu.Item
                            href={'https://twitter.com/guiainbh/'}
                            target={'_blank'}
                            alt={'Twitter'}
                            title={'Twitter'}
                        >
                            <Icon name="twitter"/>
                        </Menu.Item>
                        <Menu.Item
                            href={'https://instagram.com/guiainbh/'}
                            target={'_blank'}
                            alt={'Instagram'}
                            title={'Instagram'}
                        >
                            <Icon name="instagram"/>
                        </Menu.Item>
                        <div style={{position: 'absolute', right: 16, color: '#FFF', fontSize: 11}}>
                            v3
                        </div>
                        {/*<Menu.Item>*/}
                        {/*    <Link to="/">*/}
                        {/*        <Icon name="linkedin"/>*/}
                        {/*    </Link>*/}
                        {/*</Menu.Item>*/}
                        {/*<Menu.Menu position="right">*/}
                        {/*    <Menu.Item>*/}
                        {/*        <Image src={GooglePlay}/>*/}
                        {/*    </Menu.Item>*/}
                        {/*    <Menu.Item>*/}
                        {/*        <Image src={AppleStore}/>*/}
                        {/*    </Menu.Item>*/}
                        {/*</Menu.Menu>*/}
                    </Menu>
                </Container>
            </Container>
        </Segment>
    );
}
